var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ChannelWrapper",
    _vm._b(
      { attrs: { channel: _vm.channel } },
      "ChannelWrapper",
      _vm.$props,
      false
    ),
    [
      _vm.network.channels.length > 1
        ? _c(
            "button",
            {
              staticClass: "collapse-network",
              attrs: {
                "aria-controls": "network-" + _vm.network.uuid,
                "aria-label": _vm.getExpandLabel(_vm.network),
                "aria-expanded": !_vm.network.isCollapsed,
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.onCollapseClick.apply(null, arguments)
                },
              },
            },
            [_c("span", { staticClass: "collapse-network-icon" })]
          )
        : _c("span", { staticClass: "collapse-network" }),
      _c("div", { staticClass: "lobby-wrap" }, [
        _c(
          "span",
          { staticClass: "name", attrs: { title: _vm.channel.name } },
          [_vm._v(_vm._s(_vm.channel.name))]
        ),
        _vm.network.status.connected && !_vm.network.status.secure
          ? _c(
              "span",
              {
                staticClass: "not-secure-tooltip tooltipped tooltipped-w",
                attrs: { "aria-label": "Insecure connection" },
              },
              [_c("span", { staticClass: "not-secure-icon" })]
            )
          : _vm._e(),
        !_vm.network.status.connected
          ? _c(
              "span",
              {
                staticClass: "not-connected-tooltip tooltipped tooltipped-w",
                attrs: { "aria-label": "Disconnected" },
              },
              [_c("span", { staticClass: "not-connected-icon" })]
            )
          : _vm._e(),
        _vm.channel.unread
          ? _c(
              "span",
              {
                staticClass: "badge",
                class: { highlight: _vm.channel.highlight },
              },
              [_vm._v(_vm._s(_vm.unreadCount))]
            )
          : _vm._e(),
      ]),
      _c(
        "span",
        {
          staticClass:
            "add-channel-tooltip tooltipped tooltipped-w tooltipped-no-touch",
          attrs: { "aria-label": _vm.joinChannelLabel },
        },
        [
          _c("button", {
            class: ["add-channel", { opened: _vm.isJoinChannelShown }],
            attrs: {
              "aria-controls": "join-channel-" + _vm.channel.id,
              "aria-label": _vm.joinChannelLabel,
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$emit("toggle-join-channel")
              },
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }